import { render, staticRenderFns } from "./GridTableDeleted.vue?vue&type=template&id=7b4f061e"
import script from "./GridTableDeleted.vue?vue&type=script&lang=js"
export * from "./GridTableDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports